var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEcommerce = function SvgEcommerce(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 33"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.602 4.776 1.544 15.926a2 2 0 0 0-.569 2.682l6.43 10.588a2 2 0 0 0 2.837.614l5.757-3.932z",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32.215 5.4A2 2 0 0 1 33 6.988V30.5a2 2 0 0 1-2 2H18a2 2 0 0 1-2-2V6.988a2 2 0 0 1 .785-1.588l6.5-4.97a2 2 0 0 1 2.43 0zM24.5 13a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7",
    clipRule: "evenodd"
  })));
};
export default SvgEcommerce;